import { useMutation } from "react-query";
import { SharedLessonApi } from "@api/SharedLessonApi";

export const useCancelSharedLesson = () => {
  return useMutation(["shared-lesson"], SharedLessonApi.cancelById);
};
